import React, { useState } from 'react';

const AnnualQuarterAllSwitch = ({ onPeriodChange }) => {
    // ラジオボタンの状態を管理する useState
    const [selectedOption, setSelectedOption] = useState('all'); // 初期状態は 'annual'

    // ラジオボタンが変更されたときに状態を更新し、親コンポーネントに通知
    const handleOptionChange = (e) => {
        const newValue = e.target.value;
        setSelectedOption(newValue);
        // 親コンポーネントのコールバック関数を呼び出して状態を伝える
        onPeriodChange(newValue);
    };

    return (
        <div className="annual-quarter-all-grouping radio-grouping">
            <div className="annual-quarter-all-grouping-all-element">
                <input
                    className="annual-quarter-all-grouping-input radio-grouping-input"
                    type="radio"
                    name="annual-quarter-all-grouping"
                    id="annual-quarter-all-grouping-all"
                    value="all"
                    checked={selectedOption === 'all'} // 選択された場合にチェック
                    onChange={handleOptionChange}
                />
                <label
                    className="annual-quarter-all-grouping-label radio-grouping-label"
                    htmlFor="annual-quarter-all-grouping-all"
                    data-active={selectedOption === 'all'}
                >
                    All
                </label>
            </div>
            <div className="annual-quarter-all-grouping-annual-element">
                <input
                    className="annual-quarter-all-grouping-input radio-grouping-input"
                    type="radio"
                    name="annual-quarter-all-grouping"
                    id="annual-quarter-all-grouping-annual"
                    value="annual"
                    checked={selectedOption === 'annual'} // 選択された場合にチェック
                    onChange={handleOptionChange}
                />
                <label
                    className="annual-quarter-all-grouping-label radio-grouping-label"
                    htmlFor="annual-quarter-all-grouping-annual"
                    data-active={selectedOption === 'annual'}
                >
                    Annual
                </label>
            </div>
            <div className="annual-quarter-all-grouping-quarterly-element">
                <input
                    className="annual-quarter-all-grouping-input radio-grouping-input"
                    type="radio"
                    name="annual-quarter-all-grouping"
                    id="annual-quarter-all-grouping-quarterly"
                    value="quarter"
                    checked={selectedOption === 'quarter'} // 選択された場合にチェック
                    onChange={handleOptionChange}
                />
                <label
                    className="annual-quarter-all-grouping-label radio-grouping-label"
                    htmlFor="annual-quarter-all-grouping-quarterly"
                    data-active={selectedOption === 'quarter'}
                >
                    Quarter
                </label>
            </div>
        </div>
    );
};

export default AnnualQuarterAllSwitch;
